import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useAuthContext } from '@/auth';
import { FormattedMessage } from 'react-intl';
import { Modal as AntModal, Spin } from 'antd';

const ActiveAccount = () => {
  const { token } = useParams();
  const { verifyAccount } = useAuthContext();
  const [showLoadingModal, setShowLoadingModal] = useState(true);
  const hasProcessedRef = useRef(false);

  useEffect(() => {
    if (!token || hasProcessedRef.current) return;
    let isMounted = true;

    const handleAccountActivation = async () => {
      hasProcessedRef.current = true;
      try {
        const result = await verifyAccount(token);
        const success = result?.status === 200 && result?.message === 'Account activated successfully';
        const target = success ? '/auth/verified-email' : '/auth/activation-failed';
        window.location.replace(target);
      } catch (error) {
        window.location.replace('/auth/activation-failed');
      } finally {
        if (isMounted) setShowLoadingModal(false);
      }
    };

    handleAccountActivation();
    return () => {
      isMounted = false;
    };
  }, [token, verifyAccount]);

  return (
    <AntModal
      open={showLoadingModal}
      footer={null}
      closable={false}
      centered
      maskClosable={false}
      width={300}
      onCancel={() => {}} // Prevent closing
    >
      <div className="flex flex-col items-center gap-3 py-4">
        <Spin size="large" />
        <div className="text-sm text-gray-700">
          <FormattedMessage id="ATTACH_FILES.LOADING_DATA" defaultMessage="Đang nhập dữ liệu..." />
        </div>
      </div>
    </AntModal>
  );
};

export default ActiveAccount;
